import { Link } from 'react-router-dom';
import { FileText, ChevronLeft } from 'lucide-react';

export const Header = ({ showBack = false, backTo = "/" }) => {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200">
      <div className="container-app">
        <div className="flex items-center justify-between h-16">
          {showBack ? (
            <Link 
              to={backTo} 
              className="flex items-center gap-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="back-button"
            >
              <ChevronLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Retour</span>
            </Link>
          ) : (
            <div className="w-20" />
          )}
          
          <Link 
            to="/" 
            className="flex items-center gap-2"
            data-testid="logo-link"
          >
            <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center">
              <FileText className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold text-primary">PDF Facile</span>
          </Link>
          
          <div className="w-20" />
        </div>
      </div>
    </header>
  );
};

export default Header;
